import { Link } from "react-router-dom";
import { Lock, Crown } from "lucide-react";

export const PLAN_NAMES = { gratis: "Grátis", medio: "Médio", pro: "Pro" };

// Selo do plano atual no header. Clica → página de planos.
export function PlanBadge({ plano }) {
  const p = plano || "gratis";
  const styles = {
    gratis: "border-border text-muted-foreground hover:text-foreground",
    medio: "border-violet-500/50 bg-violet-500/10 text-violet-300",
    pro: "border-amber-500/50 bg-amber-500/10 text-amber-300",
  };
  return (
    <Link
      to="/planos"
      data-testid="plan-badge"
      title="Ver planos"
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide transition ${styles[p] || styles.gratis}`}
    >
      {p === "pro" && <Crown className="h-3 w-3" />}
      {PLAN_NAMES[p] || p}
    </Link>
  );
}

// Aviso inline quando o backend devolve 402 (limite batido ou recurso bloqueado).
export function UpgradeNotice({ info, onDismiss }) {
  if (!info) return null;
  const alvo = PLAN_NAMES[info.plano_necessario] || "Médio";
  return (
    <div data-testid="upgrade-notice" className="rounded-xl border border-violet-500/40 bg-violet-500/10 p-3 flex items-start gap-2.5">
      <Lock className="h-4 w-4 text-violet-300 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-foreground/90">{info.mensagem || `Esse recurso faz parte do plano ${alvo}.`}</p>
        <div className="mt-2 flex items-center gap-2">
          <Link
            to="/planos"
            data-testid="upgrade-cta"
            className="rounded-full bg-violet-600 hover:bg-violet-500 text-white px-4 py-1.5 text-xs font-medium transition"
          >
            Desbloquear no plano {alvo}
          </Link>
          {onDismiss && (
            <button onClick={onDismiss} className="text-xs text-muted-foreground hover:text-foreground px-2 py-1.5">
              Agora não
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// Corpo de modal quando a feature inteira é de plano superior — mostra o que o aluno
// está perdendo (não some) + CTA de upgrade.
export function LockedFeature({ titulo, descricao, planoNecessario = "medio" }) {
  const alvo = PLAN_NAMES[planoNecessario] || "Médio";
  return (
    <div data-testid="locked-feature" className="flex flex-col items-center text-center gap-3 py-8 px-5">
      <div className="rounded-full bg-violet-500/10 p-4">
        <Lock className="h-7 w-7 text-violet-400" strokeWidth={1.5} />
      </div>
      <div>
        <h3 className="font-bold tracking-tight">{titulo} 🔒</h3>
        <p className="text-sm text-muted-foreground mt-1 max-w-sm">{descricao}</p>
      </div>
      <Link
        to="/planos"
        data-testid="locked-feature-cta"
        className="rounded-full bg-violet-600 hover:bg-violet-500 text-white px-5 py-2.5 text-sm font-medium transition"
      >
        Desbloquear no plano {alvo}
      </Link>
    </div>
  );
}
